import { render, staticRenderFns } from "./FunctionSwitchListPage.vue?vue&type=template&id=457db948&scoped=true"
import script from "./FunctionSwitchListPage.vue?vue&type=script&lang=js"
export * from "./FunctionSwitchListPage.vue?vue&type=script&lang=js"
import style0 from "./FunctionSwitchListPage.vue?vue&type=style&index=0&id=457db948&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457db948",
  null
  
)

export default component.exports